"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: !0
}), exports.render = exports.update = void 0;

var _d = require("d3"),
    _isEmpty = _interopRequireDefault(require("lodash-es/isEmpty")),
    _isArray = _interopRequireDefault(require("lodash-es/isArray")),
    _util = require("../util"),
    _getNeedleTransition = require("../util/get-needle-transition"),
    _configure = require("../config/configure"),
    update = function update(a) {
  var b = a.d3_refs,
      c = a.newValue,
      d = a.config,
      e = (0, _configure.configureScale)(d),
      f = e(c),
      g = d.maxAngle - d.minAngle,
      h = d.minAngle + f * g;
  b.pointer.transition().duration(d.needleTransitionDuration).ease((0, _getNeedleTransition.getNeedleTransition)(d.needleTransition)).attr("transform", "rotate(".concat(h, ")")), b.current_value_text.text((0, _util.formatCurrentValueText)(c, d));
};

exports.update = update;

var render = function render(a) {
  var b = a.container,
      c = a.config,
      d = (0, _util.getRadius)(c),
      e = (0, _util.centerTranslation)(d, c.paddingHorizontal, c.paddingVertical),
      f = _renderSVG({
    container: b,
    config: c
  });

  return _renderArcs({
    config: c,
    svg: f,
    centerTx: e
  }), _renderLabels({
    config: c,
    svg: f,
    centerTx: e,
    r: d
  }), {
    current_value_text: _renderCurrentValueText({
      config: c,
      svg: f
    }),
    pointer: _renderNeedle({
      config: c,
      svg: f,
      r: d,
      centerTx: e
    })
  };
};

exports.render = render;

function _renderSVG(a) {
  var b = a.container,
      c = a.config,
      d = c.width + 2 * c.paddingHorizontal,
      e = c.height + 2 * c.paddingVertical;
  return (0, _d.select)(b).append("svg:svg").attr("class", "speedometer").attr("width", "".concat(d).concat(c.dimensionUnit)).attr("height", "".concat(e).concat(c.dimensionUnit)).style("width", "".concat(d).concat(c.dimensionUnit)).style("height", "".concat(e).concat(c.dimensionUnit));
}

function _renderArcs(a) {
  var b = a.config,
      c = a.svg,
      d = a.centerTx,
      e = (0, _configure.configureTickData)(b),
      f = (0, _configure.configureArc)(b),
      g = c.append("g").attr("class", "arc").attr("transform", d);
  g.selectAll("path").data(e).enter().append("path").attr("class", "speedo-segment").attr("fill", function (a, c) {
    return !(0, _isEmpty["default"])(b.segmentColors) && b.segmentColors[c] ? b.segmentColors[c] : b.arcColorFn(a * c);
  }).attr("d", f);
}

function _renderLabels(a) {
  var b = a.config,
      c = a.svg,
      d = a.centerTx,
      e = a.r,
      f = (0, _configure.configureTicks)(b),
      g = (0, _configure.configureTickData)(b),
      h = (0, _configure.configureScale)(b),
      j = b.maxAngle - b.minAngle,
      k = b.customSegmentLabels,
      l = (0, _isArray["default"])(k) && !(0, _isEmpty["default"])(k),
      m = l && k.length === g.length;
  if (l && !m) throw new Error("Custom Segment Labels should be an array with length of ".concat(g.length));
  if (l && m) return void _renderCustomSegmentLabels({
    config: b,
    svg: c,
    centerTx: d,
    r: e,
    ticks: f,
    tickData: g,
    scale: h,
    range: j
  });
  var n = c.append("g").attr("class", "label").attr("transform", d);
  n.selectAll("text").data(f).enter().append("text").attr("transform", function (a, c) {
    var d = 0 === b.customSegmentStops.length ? h(a) : (0, _util.sumArrayTill)(g, c),
        f = b.minAngle + d * j;
    return "rotate(".concat(f, ") translate(0, ").concat(b.labelInset - e, ")");
  }).text(b.labelFormat).attr("class", "segment-value").style("text-anchor", "middle").style("font-size", b.labelFontSize).style("font-weight", "bold").style("fill", b.textColor);
}

function _renderCustomSegmentLabels(a) {
  function b(a, b) {
    var d = 0 === l.length ? j(a) : (0, _util.sumArrayTill)(h, b),
        e = c.minAngle + d * k;
    return e;
  }

  var c = a.config,
      d = a.svg,
      e = a.centerTx,
      f = a.r,
      g = a.ticks,
      h = a.tickData,
      j = a.scale,
      k = a.range,
      l = c.customSegmentStops,
      m = c.customSegmentLabels,
      n = m.map(function (a, c) {
    var d = c,
        e = c + 1,
        f = g[d],
        h = b(f, d),
        i = g[e],
        j = b(i, e);
    return (j + h) / 2;
  }),
      o = f - c.ringWidth - c.ringInset,
      p = f - c.ringInset,
      q = d.append("g").attr("class", "label").attr("transform", e);
  q.selectAll("text").data(m).enter().append("text").attr("transform", function (a, b) {
    var d = n[b],
        e = "rotate(".concat(d, ") translate(0, ").concat(c.labelInset - f, ")"),
        g = "rotate(".concat(d, ") translate(0, ").concat(c.labelInset / 2 - (p - (p - o) / 2), ")");
    return "OUTSIDE" === a.position ? e : g;
  }).text(function (a) {
    return a.text || "";
  }).attr("class", "segment-value").style("text-anchor", "middle").style("font-size", function (a) {
    return a.fontSize || c.labelFontSize;
  }).style("font-weight", "bold").style("fill", function (a) {
    return a.color || c.textColor;
  });
}

function _renderCurrentValueText(a) {
  var b = a.config,
      c = a.svg,
      d = (b.width + 2 * b.paddingHorizontal) / 2,
      e = (b.width + 4 * b.paddingVertical) / 2;
  return c.append("g").attr("transform", "translate(".concat(d, ", ").concat(e, ")")).append("text").attr("class", "current-value").attr("text-anchor", "middle").attr("y", 23).text(b.currentValue).style("font-size", b.valueTextFontSize).style("font-weight", "bold").style("fill", b.textColor);
}

function _renderNeedle(a) {
  var b = a.config,
      c = a.svg,
      d = a.r,
      e = a.centerTx,
      f = (0, _util.calculateNeedleHeight)({
    heightRatio: b.needleHeightRatio,
    radius: d
  }),
      g = [[b.pointerWidth / 2, 0], [0, -f], [-(b.pointerWidth / 2), 0], [0, b.pointerTailLength], [b.pointerWidth / 2, 0]],
      h = (0, _d.line)().curve(_d.curveMonotoneX),
      i = c.append("g").data([g]).attr("class", "pointer").attr("transform", e).style("fill", b.needleColor);
  return i.append("path").attr("d", h).attr("transform", "rotate(".concat(b.minAngle, ")"));
}